import { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const [loc, setLoc] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("saipass_loc")) || { state: "", city: "" };
    } catch {
      return { state: "", city: "" };
    }
  });

  useEffect(() => {
    localStorage.setItem("saipass_loc", JSON.stringify(loc));
  }, [loc]);

  return (
    <LocationContext.Provider value={{ loc, setLoc }}>
      {children}
    </LocationContext.Provider>
  );
}

export const useLocationCtx = () => useContext(LocationContext);
